import {ValueObject} from '@s-ui/domain'

export class UpdateCurrentUserRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.avatar
   * @param {String} data.name
   * @param {String} data.lastName
   * @param {String} data.phone
   * @param {Number} data.provinceID
   * @param {String} data.token
   * @param {String} data.zipCode
   **/
}
